import React, { useEffect, useState } from "react";
import {
  getFirestore,
  collection,
  query,
  getDocs,
  addDoc,
  orderBy,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { useNavigate, useParams } from "react-router-dom";
import GetUserData from "../../Hooks/GetUserData";
import { useUserPermissions } from "../../Hooks/GetUserPermissions";

const db = getFirestore();
const auth = getAuth();

const HistorialCompras = () => {
  const { hubId } = useParams();
  const navigate = useNavigate();

  const [restaurantes, setRestaurantes] = useState([]);
  const [selectedRestaurante, setSelectedRestaurante] = useState("general");
  const [compras, setCompras] = useState([]);
  const [tipo, setTipo] = useState("comida");
  const [distribuidor, setDistribuidor] = useState("");
  const [precio, setPrecio] = useState("");
  const [comentario, setComentario] = useState("");
  const [cargando, setCargando] = useState(false);

  const { userData, loadingB } = GetUserData();

  const isSuperAdmin = !loadingB && userData?.hubId?.includes('__superadmin__');

  const { permisos, loading } = useUserPermissions();

  const isAdmin = !loading && (
    permisos.verCompras === 'lectura_escritura' || isSuperAdmin
  );

  useEffect(() => {
    const cargarRestaurantes = async () => {
      const refEmpresas = collection(db, "private-hubs", hubId, "Empresas");
      const snapshot = await getDocs(refEmpresas);
      const lista = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      setRestaurantes([{ id: "general", nombre: "Compras generales" }, ...lista]);
    };
    cargarRestaurantes();
  }, [hubId]);

  const cargarCompras = async () => {
    setCargando(true);
    let comprasSnapshot;

    const empresaId = selectedRestaurante;
    const refCompras = collection(
      db,
      "private-hubs",
      hubId,
      "Empresas",
      empresaId,
      "Compras"
    );
    comprasSnapshot = await getDocs(query(refCompras, orderBy("fecha", "desc")));

    const listaCompras = comprasSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setCompras(listaCompras);
    setCargando(false);
  };

  useEffect(() => {
    if (selectedRestaurante && hubId) {
      cargarCompras(selectedRestaurante);
    }
    //eslint-disable-next-line
  }, [selectedRestaurante, hubId]);

  const usuario = auth.currentUser;

  const agregarCompra = async () => {
    if (!distribuidor || !precio) {
      alert("Por favor completa todos los campos");
      return;
    }
    try {
      const empresaId = selectedRestaurante;
      await addDoc(
        collection(db, "private-hubs", hubId, "Empresas", empresaId, "Compras"),
        {
          tipo,
          distribuidor,
          precio: parseFloat(precio),
          comentario: comentario || "",
          usuario: usuario.uid,
          usuarioEmail: usuario.email,
          fecha: new Date(),
        }
      );
      setDistribuidor("");
      setPrecio("");
      setComentario("");
      await cargarCompras(selectedRestaurante); 
    } catch (error) {
      console.error("Error agregando compra: ", error);
      alert("Error al guardar compra");
    }
  };

  const restauranteSeleccionado = restaurantes.find(
    (r) => r.id === selectedRestaurante
  );

  return (
    <div className="lobby-container">
      <div className="header-container">
        <header className="header">
          <h1 className="header-title">Historial de Compras</h1>
          <div className="logout-button-container">
            <button onClick={() => navigate(-1)} className="logout-button">
              ← Volver
            </button>
          </div>
        </header>
      </div>

      {/* Selector de restaurante */}
      <div className="data-box" style={{padding: "20px"}}>
        <label className="labelText">Selecciona local:</label>
        <select
          className="compras-form-input"
          value={selectedRestaurante}
          onChange={(e) => setSelectedRestaurante(e.target.value)}
        >
          {restaurantes.map((r) => (
            <option key={r.id} value={r.id}>
              {r.nombre}
            </option>
          ))}
        </select>
      </div>

      {/* Formulario de compra */}
      { isAdmin && (
        <div className="data-box" >
          <h3 className="data-box-title" style={{paddingBottom: "20px"}}>Añadir compra</h3>

          <label className="labelText">Tipo:</label>
          <select
            className="compras-form-input"
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
          >
            <option value="comida">Comida</option>
            <option value="bebida">Bebida</option>
            <option value="otro">Otro</option>
          </select>

          <label className="labelText">Distribuidor:</label>
          <input
            className="compras-form-input"
            type="text"
            value={distribuidor}
            onChange={(e) => setDistribuidor(e.target.value)}
            placeholder="Nombre del distribuidor"
          />

          <label className="labelText">Precio (sin IVA):</label>
          <input
            className="compras-form-input"
            type="number"
            value={precio}
            onChange={(e) => setPrecio(e.target.value)}
            placeholder="Precio (sin IVA)"
            step="0.01"
            min="0"
          />

          <label className="labelText">Comentarios:</label>
          <textarea
            className="compras-form-input"
            onChange={(e) => setComentario(e.target.value)}
            step="0.01"
            min="0"
          />

          <button className="seccion-btn" onClick={agregarCompra}>
            Guardar compra
          </button>
        </div>
      )}

      {/* Lista de compras */}
      <div className="data-box">
      <h3 className="data-box-title">
        Lista de compras{" "}
        {selectedRestaurante === "general"
          ? "General"
          : `local ${restauranteSeleccionado?.nombre || selectedRestaurante}`}
      </h3>

        {cargando ? (
          <p>Cargando compras...</p>
        ) : compras.length === 0 ? (
          <p>No hay compras registradas.</p>
        ) : (
          <div className="table-responsive">
            <table className="data-table">
              <thead>
                <tr className="tier1-data">
                  <th>Tipo</th>
                  <th>Distribuidor</th>
                  <th>Precio</th>
                  <th>Usuario</th>
                  <th>Fecha</th>
                  <th>Comentario</th>
                </tr>
              </thead>
              <tbody>
                {compras.map((c) => (
                  <tr key={c.id} className="accion-row">
                    <td>{c.tipo}</td>
                    <td>{c.distribuidor}</td>
                    <td>{c.precio.toFixed(2)} €</td>
                    <td>{c.usuarioEmail || c.usuario}</td>
                    <td>
                      {c.fecha.toDate
                        ? c.fecha.toDate().toLocaleString()
                        : new Date(c.fecha).toLocaleString()}
                    </td>
                    <td>{c.comentario}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistorialCompras;
